import { Dropdown } from '@pandiafi/design-system'
import { Field, FieldProps, useFormikContext } from 'formik'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import FormFieldWrapper from 'components/FormField'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'

type PresenterOption = {
  id: string
  label: string
}

interface PresenterTenantFieldProps {
  options: PresenterOption[]
}

export const PresenterTenantField: React.FC<PresenterTenantFieldProps> = ({
  options,
}) => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const { values, setFieldValue } = useFormikContext<FormValues>()

  useEffect(() => {
    if (!values.displaysSelf && values.presenterTenantUuid !== null) {
      void setFieldValue('presenterTenantUuid', null, false)
      return
    }

    const defaultOptionId = options[0]?.id

    if (
      values.displaysSelf &&
      values.presenterTenantUuid === null &&
      defaultOptionId
    ) {
      void setFieldValue('presenterTenantUuid', defaultOptionId, false)
    }
  }, [options, setFieldValue, values.displaysSelf, values.presenterTenantUuid])

  if (!values.displaysSelf) {
    return null
  }

  return (
    <Field name="presenterTenantUuid">
      {({ field, meta, form }: FieldProps<FormValues['presenterTenantUuid']>) =>
        (() => {
          const selectedOption =
            typeof meta.value === 'string'
              ? (options.find((option) => option.id === meta.value) ?? null)
              : null

          return (
            <FormFieldWrapper
              name={field.name}
              label={t('terminateContract:labels.presenter')}
              className="min-tablet:max-w-96 mt-6"
              meta={meta}
              required
              labelBold
            >
              <Dropdown
                id={field.name}
                options={options}
                placeholder={t('common:placeholders.select')}
                onChange={async (option) => {
                  await form.setFieldValue(
                    field.name,
                    option ? option.id : null
                  )
                  await form.setFieldTouched(field.name, true)
                }}
                value={selectedOption}
                allowEmpty
              />
            </FormFieldWrapper>
          )
        })()
      }
    </Field>
  )
}
